<template>
  <div>
    <DialogBase
      :visible="isOpen"
      @before-close="handleClose"
      :close-on-click-modal="false"
      width="70%"
      top="80px"
      title="Danh sách học sinh nhân sự"
      panel-icon="el-icon-user"
      panel-title="tức nhân sự"
      panel-subtitle="Chọn phòng ban và tìm kiếm nhân sự áp dụng tin tức này"
      @cancel="handleClose"
      @confirm="handleSaveForm"
      confirm-text="Xác nhận"
      cancel-text="Hủy bỏ"
    >
      <div class="body_dialog">
        <!-- Vùng Bộ lọc -->
        <div class="esf-filter-bar">
          <el-row :gutter="12" type="flex" align="bottom">
            <el-col :span="12">
              <div class="esf-filter-item">
                <span class="esf-filter-label"><i class="el-icon-folder-opened" /> Phòng ban áp dụng</span>
                <el-select
                    style="width: 100%"
                    v-model="departmentsApply"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    @change="handleChangeFilter"
                    placeholder="Chọn phòng ban"
                    class="esf-select"
                >
                  <el-option
                      v-for="(item, index) in departmentList"
                      :key="index"
                      :label="item.departmentName"
                      :value="item.id"
                  />
                </el-select>
              </div>
            </el-col>

            <el-col :span="12" v-if="departmentsApply.length > 0">
              <div class="esf-filter-item">
                <span class="esf-filter-label"><i class="el-icon-user" /> Tìm kiếm nhân sự</span>
                <el-input
                    :clearable="true"
                    style="width: 100%"
                    placeholder="Nhập tên nhân sự tìm kiếm..."
                    v-model="nameEmployees"
                    @keyup.enter.native="handleChangeFilter"
                    @clear="handleChangeFilter"
                    class="esf-input-search"
                >
                  <template #append>
                    <el-button
                        icon="el-icon-search"
                        @click="handleChangeFilter"
                    />
                  </template>
                </el-input>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- Vùng dữ liệu -->
        <div :class="['esf-list-wrapper', { 'no-data': employeesDataFilter.length === 0 }]">
          <div v-if="employeesDataFilter.length > 0">
            <div class="esf-list-header">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                Tất cả nhân sự
              </el-checkbox>
            </div>
            
            <div class="esf-scroll-area">
              <el-checkbox-group v-model="employeeApply" class="esf-checkbox-grid">
                <el-checkbox
                    class="esf-checkbox-item"
                    v-for="(employee, index) in employeesDataFilter"
                    :label="employee.idTeacher"
                    :key="index"
                >
                  <span class="esf-employee-name">{{ employee.teacherName }}</span>
                  <span class="esf-department-list">
                    <span
                        v-for="(department, depIndex) in employee.departmentTeacherApplyList"
                        :key="depIndex"
                        class="esf-department-tag"
                    >
                      {{ department.departmentName }}
                    </span>
                  </span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <div v-else class="esf-empty-state">
            <i class="el-icon-warning"/>
            <span>Vui lòng chọn phòng ban để hiển thị danh sách nhân sự</span>
          </div>
        </div>
      </div>
    </DialogBase>
  </div>
</template>

<script>
import SurveyForm from "@/services/SurveyForm";
import DialogBase from "@/components/DialogBase.vue";
import {mapState} from "vuex";

export default {
  components: { DialogBase },
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState('departmentStore', ['departmentList']),
  },
  data() {
    return {
      employeesInSchool: [],
      employeesDataFilter: [],
      departmentsApply: [],
      nameEmployees: "",
      employeeApply: [],
      checkAll: false,
      isIndeterminate: false
    }
  },

  watch: {
    departmentsApply(newVal) {
      if (newVal.length > 0) {
        this.handleChangeDepartmentApply(newVal);
      } else {
        this.employeeApply = [];
      }
    },

    employeeApply(newVal) {
      if (newVal.length === this.employeesDataFilter.length && this.employeesDataFilter.length > 0) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (newVal.length === 0){
        this.checkAll = false;
        this.isIndeterminate = false;
      } else if (newVal.length < this.employeesDataFilter.length) {
        this.checkAll = false;
        this.isIndeterminate = true;
      }
    },

    employeesDataFilter(newVal) {
      if (newVal.length > 0 && newVal.length === this.employeeApply.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (this.employeeApply.length > 0 && newVal.length > this.employeeApply.length) {
        this.checkAll = false;
        this.isIndeterminate = true;
      }

      this.handleChangeCheckApply();
    }
  },

  created() {
    this.fetchEmployeesInSchool();

    this.$store.dispatch('departmentStore/fetchDataDepartmentList');
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
    },

    handleChangeCheckApply() {
      const employeesApply = this.employeeApply;
      const dataFilter = this.employeesDataFilter;

      if (employeesApply.length > 0 && dataFilter.length && employeesApply.length > dataFilter.length) {
        const employeeIds = dataFilter.map(employee => employee.idTeacher);

        this.employeeApply = employeesApply.filter(id => employeeIds.includes(id));
      }
    },

    fetchEmployeesInSchool() {
      SurveyForm.getAllEmployeesSchool()
          .then((res) => {
            this.employeesInSchool = res.data.data;
              if (this.departmentsApply.length > 0) {
            this.handleChangeFilter();
          }
          })
          .catch((err) => {
            console.log(err);
          })
    },

    handleCheckAllChange(val) {
      this.employeeApply = val ? this.getDataIdEmployees(this.employeesDataFilter) : [];
      this.isIndeterminate = false;
    },

    handleChangeFilter() {
      const idDepartmentList = this.departmentsApply;
      const name = this.nameEmployees;
      const employees = this.employeesInSchool;
      const result = []

      idDepartmentList.map((id) => {
        employees.map((employee) => {
          employee.departmentTeacherApplyList.map((department) => {
            if (department.idDepartment === id && name !== "") {
              if (this.removeVietnameseTones(employee.teacherName).includes(this.removeVietnameseTones(name))) {
                result.push(employee);
              }
            } else if (department.idDepartment === id && name === "") {
              result.push(employee);
            }
          })
        })
      })

       this.employeesInSchool.forEach(employee => {
        if (this.employeeApply.includes(employee.idTeacher)) {
          const belongsToSelectedDepartment = employee.departmentTeacherApplyList.some(department =>
            idDepartmentList.includes(department.idDepartment)
          );
          if (belongsToSelectedDepartment) {
            result.push(employee);
          }
        }
      });

      this.employeesDataFilter = Object.values(
          result.reduce((employee, item) => {
            employee[item.idTeacher] = item; // Ghi đè đối tượng nếu ID trùng lặp
            return employee;
          }, {})
      );
    },

    removeVietnameseTones(str) {
      return str
          .normalize("NFD") // Tách các dấu tiếng Việt thành ký tự riêng
          .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toLowerCase(); // Chuyển về chữ thường
    },

    handleSaveForm() {
      const data = {
        departmentsApply: this.employeeApply.length === 0 ? [] : this.departmentsApply,
        employeesApply: this.getDataEmployees(this.employeeApply),
      }
      this.$emit('confirmData', data);
      this.resetData();
    },

    getDataEmployees(idEmployees) {
      const employees = this.employeesDataFilter;
      return employees.filter(employee => idEmployees.includes(employee.idTeacher));
    },

    getDataIdEmployees(employees) {
      const idEmployees = [];
      employees.map(employee => {
        idEmployees.push(employee.idTeacher);
      })
      return idEmployees;
    },

    initialDataApply(departments, employees) {
      this.departmentsApply = departments ;
      this.employeeApply = employees;
      this.handleChangeFilter();
    },

    resetData() {
      this.employeesDataFilter = [];
      this.departmentsApply = [];
      this.nameEmployees = "";
      this.checkAll = false;
      this.isIndeterminate = false;
    },

    handleChangeDepartmentApply(value) {
      if (this.employeeApply.length > 0) {
        // Gán lại danh sách đã lọc
        this.employeeApply = this.employeeApply.filter(employee => {
          return employee.departmentTeacherApplyList.some(department =>
              value.includes(department.idDepartment)
          );
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.body_dialog {
  padding: 4px 0;
}

/* ─── Filter Bar ───────────────────────────────────── */
.esf-filter-bar {
  margin-bottom: 16px;
  background: #ffffff;
  padding: 4px 0;
}

.esf-filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.esf-filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  
  i {
    color: #2563eb;
    font-size: 14px;
  }
}

/* Bo góc cho input và select */
/deep/ .esf-select .el-input__inner,
/deep/ .esf-input-search .el-input__inner {
  border-radius: 10px;
  background: #f8fafc;
  border-color: #e2e8f0;
  transition: all 0.2s ease;
  height: 40px;
  line-height: 40px;
}

/deep/ .esf-select .el-input__inner:focus,
/deep/ .esf-input-search .el-input__inner:focus {
  border-color: #2563eb;
  background: #ffffff;
}

/deep/ .esf-select .el-select__tags {
  padding-left: 6px;
}

/deep/ .esf-input-search .el-input-group__append {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background: #f1f5f9;
  border-color: #e2e8f0;
  padding: 0 16px;
  
  .el-button {
    margin: -10px -16px;
    border-radius: 0 10px 10px 0;
    color: #475569;
    
    &:hover {
      color: #2563eb;
    }
  }
}

/* ─── List Wrapper ─────────────────────────────────── */
.esf-list-wrapper {
  min-height: 380px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  
  &.no-data {
    justify-content: center;
    align-items: center;
  }
}

.esf-list-header {
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
  
  /deep/ .el-checkbox__inner {
    border-radius: 4px;
    width: 18px;
    height: 18px;
    border-color: #cbd5e1;
  }
  
  /deep/ .el-checkbox__label {
    font-weight: 700;
    color: #1e293b;
    font-size: 14px;
  }
}

.esf-scroll-area {
  height: 380px;
  overflow-y: auto;
  padding-right: 4px;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
    
    &:hover {
      background: #94a3b8;
    }
  }
}

/* ─── Checkbox Grid ────────────────────────────────── */
.esf-checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 4px 0;
}

/deep/ .esf-checkbox-item {
  margin: 0 !important;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  
  &:hover {
    border-color: #2563eb;
    background: #f0f6ff;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(37, 99, 235, 0.05);
  }
  
  .el-checkbox__inner {
    border-radius: 4px;
    width: 18px;
    height: 18px;
    border-color: #cbd5e1;
  }
  
  &.is-checked {
    border-color: #2563eb;
    background: #eff6ff;
    
    .el-checkbox__inner {
      background-color: #2563eb;
      border-color: #2563eb;
    }
  }
  
  .el-checkbox__label {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 13.5px;
    padding-left: 10px;
    white-space: normal;
  }
}

.esf-employee-name {
  font-weight: 600;
  color: #1e293b;
}

.esf-department-list {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: 8px;
}

.esf-department-tag {
  font-size: 11px;
  background: #f1f5f9;
  color: #475569;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #e2e8f0;
}

/* ─── Empty State ──────────────────────────────────── */
.esf-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  
  i {
    font-size: 32px;
    color: #3b82f6;
  }
}
</style>